export default __webpack_public_path__ + "assets/icons/more.c8aa7853.svg";